module.exports = __webpack_public_path__ + "static/media/capi-actualites.ac41fa08.png";